<!--
Author: TangChen
Date: 2019-11-14
Desc: 机构登录用户账户选择
 -->
<template>
    <div class="comp-user-check comp">
        <!--内容-->
        <el-dialog
            title="机构账户选择"
            :visible.sync="visible"
            :center="true"
            class="org-acct-check"
            :show-close="false"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
        >
            <div class="protocol-con">
                <el-radio-group v-model="radio" class="clear">
                    <el-radio v-for="i in checkList" :key="i.custid" :label="i.custid" border class="left">
                        <div class="info">
                            <div><span>证件类型：</span>{{ $cache.getDict(i.invtp==="2"?"120095":"130008",i.certificatetype) }}</div>
                            <div><span>证件号码：</span>{{ i.certificateno }}</div>
                            <div class="name k-text-flow">
                                <span>机构名称：</span>{{ i.custname }}
                            </div>
                        </div>
                    </el-radio>
                </el-radio-group>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" v-on:click.prevent="backTo">
                    都不是我的登录的机构，退出
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
export default {
    name: "CompUserCheck",
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        checkList: {
            type: Array,
            default: ()=>{
                return [];
            }
        }
    },
    data () {
        return {
            radio: ""
        };
    },
    watch: {
        radio(val){
            if(val){
                const _x = val;
                this.radio = "";
                this.$emit("back-sel",_x);
            }

        }
    },
    mounted() {
    },
    methods: {
        backTo(){
            this.$emit("back-sel",false);
        }
    }
};
</script>
<style lang="scss">
    .comp-user-check {
        .protocol-con{padding: 0 10px;}
        .el-radio-group{
            .el-radio{margin-right: 15px;}
            .is-bordered{
                padding: 12px 20px;
                height: auto;
                margin-bottom: 20px;
                border-width: 2px;
                .el-radio__input{display: none;}
                .el-radio__label{width: 231px;display: inline-block;padding-left: 0;}
            }
            .el-radio.is-bordered+.el-radio.is-bordered{margin-left: 0;}
            // .el-radio:nth-child(3n){margin-right: 0;}
        }
        .el-radio__label .info{
            line-height: 24px;
            .name{font-size: 14px;width: 100%;}
        }
        /*颜色，背景写在css/theme.scss内components style下*/
    }
</style>
